import React, { useCallback, useMemo } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useTimeRecordsTotalInfo } from "~/repository";
import { hoursFormatted, decimalToMinutes } from "~/utils/utils.jsx";
import { TimeRecordTotalRealtimeEvents } from "../TimeRecordForm/TimeRecordTotalRealtimeEvents";

const TrackedTime = ({ parentId, showModal }) => {
  const { data } = useTimeRecordsTotalInfo("Task", parentId);
  const value = decimalToMinutes(data?.your_time) + decimalToMinutes(data?.other_time);

  const disabledLink = value === 0;

  const onClickCallback = useCallback(
    (event) => {
      if (disabledLink) {
        return;
      }
      showModal(event);
    },
    [disabledLink, showModal]
  );

  const total = useMemo(() => {
    return hoursFormatted({ hours: 0, minutes: value });
  }, [value]);

  return (
    <>
      <TimeRecordTotalRealtimeEvents
        parentId={parentId}
        parentType="Task"
      />
      <button
        className={classnames("c-pill-box__sum", {
          tracked_disabled_link: disabledLink,
        })}
        onClick={onClickCallback}
        data-testid="hours-sum"
      >
        {total}
        <sub>h</sub>
      </button>
    </>
  );
};

TrackedTime.propTypes = {
  parentId: PropTypes.number,
  showModal: PropTypes.func,
};

TrackedTime.defaultProps = {
  showModal: () => null,
};

export default TrackedTime;
